// extracted by mini-css-extract-plugin
export default {"EledoPropertyList":"EledoPropertyList_EledoPropertyList__czYoB","addRowButton":"EledoPropertyList_addRowButton__15Wvm"};